export default {
  segment_labels: {
    active: 'Activos',
    cancelled: 'Cancelados',
    completed: 'Completados',
  },
};
